export default __webpack_public_path__ + "static/media/react-logo.bc52f85f.svg";